import React from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";

// You should add these CSS rules to your project's stylesheet (e.g., index.css)
/*
.video-responsive-wrapper {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; 
}

.video-responsive-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
}
*/

const LegalInsightsOnBuyingOrLeasingCommercialProperty = () => {
  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.05, // Delay for each letter
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };

  const title = "1. Legal insights on buying or leasing commercial property.";

  return (
    <div>
      <Helmet>
        {/* Basic Meta Tags */}
        <title>
        Legal insights on buying or leasing commercial property and Sponsoring overseas skilled workers | MSB
        </title>
        <meta name="description" content="" />
        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="Legal insights on buying or leasing commercial property and Sponsoring overseas skilled workers | MSB"
        />
        <meta property="og:description" content="" />
        <meta property="og:type" content="website" />
        {/* Twitter Meta Tags */}
      </Helmet>
      <main className="page_content">
        {/* Page Header - Start
        ================================================== */}
        <section
          id="overview"
          className="page_header text-center section_decoration overflow-hidden"
          style={{ background: "#333" }}
        >
          <div className="container">
            <h1 className="page_title text-white">
               Legal insights on buying or leasing commercial property and Sponsoring overseas skilled workers
            </h1>
            {/* <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                flexWrap: "wrap",
              }}
            >
              {title
                .replace(/\/n/g, "\n")
                .split("\n")
                .map((line, lineIndex) => (
                  <div
                    key={`line-${lineIndex}`}
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                    }}
                  >
                    {line.split("").map((letter, charIndex) => {
                      const uniqueIndex = lineIndex * 30 + charIndex;
                      return (
                        <motion.span
                          key={`char-${lineIndex}-${charIndex}`}
                          custom={uniqueIndex}
                          initial="hidden"
                          animate="visible"
                          variants={letterVariants}
                          style={{
                            display: "inline-block",
                            marginRight: letter === " " ? "0.3rem" : "0",
                            whiteSpace: "pre",
                          }}
                        >
                          {letter}
                        </motion.span>
                      );
                    })}
                  </div>
                ))}
            </motion.h1> */}
            <ul className="breadcrumb_nav unordered_list justify-content-center d-none">
              <li>
                <NavLink to="/webinars">Webinars</NavLink>
              </li>
              <li className="active">
                <a href="#!">
                 
                </a>
              </li>
            </ul>
          </div>
        </section>
        {/* Page Header - End
        ================================================== */}
        {/* Contact Section - Start
        ================================================== */}
        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="item_details_content p-3">
              <div className="d-flex justify-content-end mb-3">
                <NavLink to="/webinars" className="btn bg-primary text-dark">
                  ← Back
                </NavLink>
              </div>
              <img
                className="rounded-2 mb-5"
                src="assets/images/webinars/legal-insights-on-buying-or-leasing-commercial-property.jpg"
                alt="Legal insights on buying or leasing commercial property and Sponsoring overseas skilled workers"
              />
              {/* <h4>Title</h4> */}
              <p className="mb-5">
               On 4th December, attendees from various industries joined a session led by <strong>Mr. Rohat Kumar, Director of Lumine Solicitors</strong>, covering both <strong>Sponsoring Overseas Skilled Workers</strong> and the <strong>legal essentials of buying or leasing commercial property</strong>. Rohat highlighted key sponsor licence requirements, compliance duties, and common mistakes employers must avoid, while also outlining important factors in commercial property deals such as lease terms, break clauses, hidden costs, and due diligence.

              </p>
              

              <div className="item_details_content p-3">
                <div className="row mb-5">
                  <div className="col-lg-3 col-md-3 col-12">
                    <div className="event-detail-bg mb-1">
                      <img
                        src="assets/images/event-banner/date.svg"
                        alt="Date"
                      />
                      <div className="text-white">
                        <h5 className="fw-bold mb-1 text-white">Date</h5>
                        <span>Thursday 04 Dec, 2025</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-12">
                    <div className="event-detail-bg mb-1">
                      <img
                        src="assets/images/event-banner/time.svg"
                        alt="Time"
                      />
                      <div className="text-white">
                        <h5 className="fw-bold mb-1 text-white">Time</h5>
                        <span>2 PM (UK TIME)</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-12">
                    <div className="event-detail-bg mb-1">
                      <img
                        src="assets/images/event-banner/platform.svg"
                        alt="Platform"
                      />
                      <div className="text-white">
                        <h5 className="fw-bold mb-1 text-white">Platform</h5>
                        <span>Google Meet</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-12">
                    <div className="event-detail-bg mb-1">
                      <img
                        src="assets/images/event-banner/attendance.svg"
                        alt="Attendance"
                      />
                      <div className="text-white">
                        <h5 className="fw-bold mb-1 text-white">Attendance</h5>
                        <span>70+ Attendees </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-4 mt-4 align-items-baseline">
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="schedule-date fw-bold fs-5">
                     Legal Insights on Buying or Leasing Commercial Property  
                    </div>
                    <div className="schedule-card">
                      <div className="schedule-item mb-2">
                        <ul>
                          <li>Legal Insights on Buying or Leasing Commercial Property</li>
                          <li>Key legal checks before buying or leasing</li>
                          <li>Understanding lease terms and hidden costs.</li>
                          <li>Negotiation tips to protect your business.</li>
                       
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="schedule-date fw-bold fs-5">
                     Sponsoring Overseas Skilled Workers
                    </div>
                    <div className="schedule-card">
                      <div className="schedule-item mb-2">
                        <ul>
                          <li>How to obtain and maintain a sponsor licence</li>
                          <li>Assigning CoS and meeting salary criteria</li>
                          <li>HR duties: checks, records, and reporting</li>
                          <li>Common compliance mistakes to avoid</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-4 mt-4 align-items-center">
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="schedule-date fw-bold fs-5">
                     What Made It Stand Out
                    </div>
                    <div className="schedule-card">
                      <div className="schedule-item mb-2">
                        <ul>
                          <li>
                            Clear, practical legal guidance from <strong>Rohat Kumar</strong>.
                          </li>
                          <li>
                            Real examples tailored to MSB challenges.
                          </li>
                          <li>Simple explanations of complex legal topics.</li>
                          <li>Interactive Q&A with actionable advice.</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <hr className="d-block d-sm-none" />

                  <div className="col-lg-6 col-md-6 col-12">
                    <img
                      src="/assets/images/webinars/Steve-Allen.png"
                      alt="Event"
                      className="img-fluid rounded-2 d-none"
                    />
                    {/* ===== RESPONSIVE IFRAME START ===== */}
                    <div className="video-responsive-wrapper">
                      <iframe
                        src="https://www.youtube.com/embed/C7tCM1CW0Eo"
                        title="Skilled Worker Sponsorship Licence Guide + Property Leasing Tips, Expert Session by Lumine Solicitors"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                      ></iframe>
                    </div>
                    {/* ===== RESPONSIVE IFRAME END ===== */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default LegalInsightsOnBuyingOrLeasingCommercialProperty;
